import { render, staticRenderFns } from "./popup-card.vue?vue&type=template&id=8a31cc62&scoped=true&"
import script from "./popup-card.vue?vue&type=script&lang=js&"
export * from "./popup-card.vue?vue&type=script&lang=js&"
import style0 from "./popup-card.vue?vue&type=style&index=0&id=8a31cc62&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a31cc62",
  null
  
)

export default component.exports